import "./App.css";
import { Route, Routes } from "react-router-dom";
import Landing from "./components/Landing/Landing";
import Contact from "./components/Contact/Contact";
import AboutUs from "./components/AboutUs/AboutUs";
import Gallery from "./components/Gallery/Gallery";
import Submission from "./components/Submission/Submission";
import OurTeam from "./components/OurTeam/OurTeam";
import NavbarElem from "./components/Navbar/Navbar";
import Blog from "./components/Blog/Blog";
import BlogPost from "./components/BlogPost/BlogPost";
import { LanguageProvider } from "./i18n/LanguageContext";
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <NavbarElem />
        <div className="pages">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:year" element={<BlogPost />} />
            <Route path="/submission" element={<Submission />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about_us" element={<AboutUs />} />
            <Route path="/our_team" element={<OurTeam />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
      </div>
    </LanguageProvider>
  );
}

export default App;
